import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import biometricReducer from "../redux/biometricSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    biometric: biometricReducer,
  },
});